import { getLocale } from "../runtime";

const sv_notifyformemailerror = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Vänligen ange en giltig e-postadress`
};

const notifyformemailerror = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_notifyformemailerror(inputs)
	return "notifyFormEmailError";
};

export { notifyformemailerror as "notifyFormEmailError" };